import React from "react";

const AudioPlayer = ({ src, type }) => {
  return (
    <audio controls>
      <source src={src} type={`audio/${type}`} />
      <a href={src}>Download {type.toUpperCase()} audio</a>.
    </audio>
  );
};

export default AudioPlayer;
